import { Box, CircularProgress, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { useNotify } from "react-admin";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGetActiveSupportChats } from "../../queries";
import { getParticipants } from "../../utils";
import { FeedbackItem } from "../feedback-item";
import { useSupportContext } from "@/stores";

const ChatsList: FC = () => {
  const notify = useNotify();
  const {
    activeSupportChats,
    activeSupportChatsError,
    isActiveSupportChatsLoading,
    fetchNextActiveSupportChatsPage,
  } = useGetActiveSupportChats();
  const { currentChat, dispatch } = useSupportContext();

  useEffect(() => {
    if (activeSupportChatsError) {
      notify("Error while fetching new feedbacks", { type: "error" });
    }
  }, [activeSupportChatsError]);

  if (isActiveSupportChatsLoading) {
    return (
      <Box display="flex" justifyContent="center" pt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (activeSupportChats?.data.length === 0) {
    return (
      <Box display="flex" justifyContent="center" pt={4}>
        <Typography variant="h4">No feedbacks found</Typography>
      </Box>
    );
  }

  if (!activeSupportChats) return;

  return (
    <InfiniteScroll
      pullDownToRefresh
      refreshFunction={() => null}
      height={"100%"}
      dataLength={10000}
      next={fetchNextActiveSupportChatsPage}
      hasMore={activeSupportChats.meta.hasNextPage}
      loader={<></>}
      style={{
        maxHeight: "100%",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        rowGap: 8,
        paddingRight: 8,
      }}
    >
      {activeSupportChats.data.map(
        ({
          id,
          isDisabled,
          lastMessage,
          participants,
          unreadMessagesCount,
        }) => {
          const { participant } = getParticipants(participants);

          return (
            <FeedbackItem
              key={id}
              time={lastMessage.createdAt}
              disabled={isDisabled || isDisabled}
              userId={participant.id}
              messagesCount={unreadMessagesCount}
              imageSrc={participant.profileImage?.path}
              body={lastMessage.content.body ?? "Attachment"}
              title={[participant.firstName, participant.lastName].join(" ")}
              active={id === currentChat?.id}
              onClick={() =>
                dispatch({
                  type: "SET_CURRENT_CHAT",
                  payload: { id, isActive: true, participant },
                })
              }
            />
          );
        }
      )}
    </InfiniteScroll>
  );
};

export { ChatsList };
